import { Country } from "./PersonalInformationType";

export const DELIVERY_ADDRESS = {
  PREBIVALISTE: "PREBIVALISTE",
  BORAVISTE: "BORAVISTE",
  DRUGA: "DRUGA",
  TRECA: "TRECA",
} as const;

export type DeliveryAddress = typeof DELIVERY_ADDRESS[keyof typeof DELIVERY_ADDRESS];

export type ContactAddressFormValues = {
  telefonPredbroj?: string;
  telefon?: string;
  mobitelPredbroj: string;
  mobitel: string;
  mailAdresa: string;

  ulica: string;
  kucniBr: string;
  mjesto: string;
  postanskiBroj: string;
  drzava?: Country;
  drzavaRegija?: Country;

  dostavaDrugaAdresa: boolean;
  dostavaUlica?: string;
  dostavaKucniBr?: string;
  dostavaMjesto?: string;
  dostavaPostanskiBroj?: string;
  dostavaDrzava?: Country;
  dostavaDrzavaRegija?: Country;

  boraviste: boolean;
  boravisteUlica?: string;
  boravisteKucniBr?: string;
  boravisteMjesto?: string;
  boravistePostanskiBroj?: string;
  boravisteDrzava?: Country;
  boravisteDrzavaRegija?: Country;

  trecaAdresa: boolean;
  trecaUlica?: string;
  trecaKucniBr?: string;
  trecaMjesto?: string;
  trecaPostanskiBroj?: string;
  trecaDrzava?: Country;
  trecaDrzavaRegija?: Country;

  adresaZaDostavuDokumentacije: DeliveryAddress;
};

export type ContactAddressInformation = ContactAddressFormValues;

export type CreateZahtjevKontaktAdresaRequest = {
  telefonPredbroj: string | null;
  telefon: string | null;
  mobitelPredbroj: string;
  mobitel: string;
  mailAdresa: string;
  ulica: string;
  kucniBr: string;
  mjesto: string;
  postanskiBroj: string;
  drzava: string;
  drzavaRegija: string | null;
  dostavaDrugaAdresa: boolean;
  dostavaUlica: string | null;
  dostavaKucniBr: string | null;
  dostavaMjesto: string | null;
  dostavaDrzava: string | null;
  dostavaDrzavaRegija: string | null;
  dostavaPostanskiBroj: string | null;
  boraviste: boolean;
  boravisteUlica: string | null;
  boravisteKucniBr: string | null;
  boravisteMjesto: string | null;
  boravisteDrzava: string | null;
  boravisteDrzavaRegija: string | null;
  boravistePostanskiBroj: string | null;
  trecaAdresa: boolean;
  trecaUlica: string | null;
  trecaKucniBr: string | null;
  trecaMjesto: string | null;
  trecaDrzava: string | null;
  trecaDrzavaRegija: string | null;
  trecaPostanskiBroj: string | null;
  adresaZaDostavuDokumentacije: string;
};

export const initialContactAddressFormValues: ContactAddressFormValues = {
  telefonPredbroj: "",
  telefon: "",
  mobitelPredbroj: "",
  mobitel: "",
  mailAdresa: "",
  ulica: "",
  kucniBr: "",
  mjesto: "",
  postanskiBroj: "",
  drzava: undefined,
  drzavaRegija: undefined,
  dostavaDrugaAdresa: false,
  dostavaUlica: "",
  dostavaKucniBr: "",
  dostavaMjesto: "",
  dostavaPostanskiBroj: "",
  dostavaDrzava: undefined,
  dostavaDrzavaRegija: undefined,
  boraviste: false,
  boravisteUlica: "",
  boravisteKucniBr: "",
  boravisteMjesto: "",
  boravistePostanskiBroj: "",
  boravisteDrzava: undefined,
  boravisteDrzavaRegija: undefined,
  trecaAdresa: false,
  trecaUlica: "",
  trecaKucniBr: "",
  trecaMjesto: "",
  trecaPostanskiBroj: "",
  trecaDrzava: undefined,
  trecaDrzavaRegija: undefined,
  adresaZaDostavuDokumentacije: DELIVERY_ADDRESS.PREBIVALISTE,
};